import { Link } from 'react-router-dom';
import { GitCompareArrows, ArrowRight } from 'lucide-react';

import ViewRecentComparisonForNavigation from './ViewRecentComparisonForNavigation';
import { Loading } from '@/app/ui/loading';
import { Error } from '@/app/ui/error';
import { useRecentComparisons } from '@/data/recentComparison';

// Flyout panel for the navigation rail's Compare item: a header, the recent
// comparison list (or a loading/empty state) and a "view all" footer. Mounted
// lazily by the flyout wrapper, so the SWR request only fires once the popover
// is opened.
const ListRecentComparisonsForNavigation = () => {
  const recentComparisons = useRecentComparisons();

  let body;
  if (recentComparisons.error) {
    body = (
      <div className="p-3">
        <Error message="Couldn't load recent comparisons." />
      </div>
    );
  } else if (!recentComparisons.data) {
    body = <Loading height={120} />;
  } else if (recentComparisons.data.query.length === 0) {
    body = (
      <div data-testid="nav-recent-comparisons-empty" className="px-4 py-8 text-center text-sm text-muted-foreground">
        No recent comparisons
      </div>
    );
  } else {
    body = (
      <div className="p-1.5">
        {recentComparisons.data.query.map((uid) => (
          <ViewRecentComparisonForNavigation key={uid} uid={uid} />
        ))}
      </div>
    );
  }

  return (
    <div data-testid="nav-recent-comparisons" className="w-80 overflow-hidden rounded-2xl border bg-popover text-popover-foreground shadow-lg">
      <div className="flex items-center justify-between border-b px-4 py-3">
        <div className="flex items-center gap-2 text-sm font-semibold">
          <GitCompareArrows className="size-4 text-muted-foreground" />
          Comparisons
        </div>
        <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Recent</span>
      </div>
      {body}
      <Link
        to="/comparison"
        data-testid="nav-recent-comparisons-view-all"
        className="flex items-center justify-between border-t px-4 py-3 text-sm font-semibold text-primary hover:bg-accent transition-colors"
      >
        View All Comparisons
        <ArrowRight className="size-4" />
      </Link>
    </div>
  );
};

export default ListRecentComparisonsForNavigation;
